/**
 * 救援司机一览
 * 创建时间：2017-08-18
 * 创建人：baixx
 */
<template>
<div class="wrapper-content fadeInRight animated tabBox" id="rescuedrive-list">
    <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
		<!--表单查询开始-->
		<div class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-1 control-label">司机编号</label>
				<div class="col-sm-2">
					<input class="form-control" v-model.trim="queryParam.driverId">
				</div>
				<label class="col-sm-1 control-label">姓名</label>
				<div class="col-sm-2">
					<input class="form-control" v-model.trim="queryParam.name">
				</div>
				<label class="col-sm-1 control-label">所属公司</label>
				<div class="col-sm-2">
					<multi-select-tree
					ref="ztree"
					:setting="setting"
           v-on:onsuccess="onsuccess"
          :isCheckAll=true
					url="/rescue-api/account/customer/fleet/"
					v-model="selectCompanysArr"
					></multi-select-tree>
				</div>
				<label class="col-sm-1 control-label">联系电话</label>
				<div class="col-sm-2">
					<input class="form-control" v-model.trim="queryParam.phone">
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">在驾车辆</label>
				<div class="col-sm-2">
					<input class="form-control" v-model.trim="queryParam.plateNumber">
				</div>
			</div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button v-if="permission.indexOf('rescueDriverList_selectDriver') == -1" type="button" class="btn btn-primary" @click="searchInfo">查询</button>
					<button type="button" class="btn btn-primary"  @click="resetQueryParams">重置</button>
				</div>
			</div>
			<div class="hr-line-dashed"></div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button type="button" class="btn btn-primary" v-show="levv==3" @click="addRescurList('add')">新增</button>
				</div>
			</div>
		</div>
		<!--表单查询结束-->
		<!--表格开始-->
		<div class="location_table" style="overflow: hidden;width:100%; position: relative;">
			<div style="overflow: auto;">
				<table style="min-width:1600px;" class="table table-striped table-bordered">
					<thead>
						<tr>
							<th>司机编号</th>
							<th>姓名</th>
							<th>电话</th>
							<th>所属公司</th>
							<th>在驾车辆</th>
							<th>绑定微信</th>
							<th>派单数</th>
							<th>接单率</th>
							<th>客户好评率</th>
							<th v-if="permission.indexOf('rescueDriverList_detail') == -1"></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(fileInfo,index) in orderList" v-bind:key="index">
							<td>DR{{fileInfo.id}}</td>
							<td>{{fileInfo.driverName}}</td>
							<td>{{fileInfo.driverPhone}}</td>
							<td>{{fileInfo.customerName}}</td>
							<td>{{fileInfo.plateNumber}}</td>
							<td>{{fileInfo.bindStatus==1?"是":"否"}}</td>
							<td>{{fileInfo.orderCount}}</td>
							<td>{{fileInfo.orderRate/100}}%</td>
							<td>{{fileInfo.positiveRate/100}}%</td>
							<td v-if="permission.indexOf('rescueDriverList_detail') == -1" class="text-center">
								<a @click="handle(fileInfo.driverName,fileInfo.id,fileInfo.bindStatus)">详情</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<!--分页组件开始-->
		<pagination v-if="orderList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
		<!--分页组件结束-->

		<!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</div>
</template>
<script>
	import Pagination from 'components/common/Pagination'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	import TabModal from 'components/common/TabModal'
	import classlist from 'util/classlist'
	import Mock from 'mockjs'
    import MultiSelectTree from 'components/common/MultiSelectTree'
	export default {
		name: "PageRescueDriverList",
		components: {
			Pagination,
			TabModal,
			Mock,
			MultiSelectTree
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["rescueDriverList"]?this.$store.state.permission.permission["rescueDriverList"]:[],
				loadingstatus:false,
				showSubPage: false,
				pageInfo:{},	                                        //分页所需信息
				orderList: [], 		                                    //表格数据列表
				messageStr: "",					                        // 弹出框内容
				scrollTop: '',
				detailInfo:{},											//报警详情对象
				selectCompanysArr:[],
				queryParam:{
					driverId: "",									// 司机编号
					name: "",							        	// 姓名
					page_index: 1,                                  // 页数
					phone: "",		                                // 联系电话
					plateNumber: "",	                            // 在驾车辆（车牌号）
				},
			    setting:{
					data: {
						simpleData: {
							enable: true,
							pIdKey: "parentId"
						}
					},
					check: {
		           		enable: true,
		           		chkboxType : { "Y" : "", "N" : "" }
		           	},
					view: {
						dblClickExpand: false,
						selectedMulti: true,
						autoCancelSelected: true
					},
					callback: {
						onCheck: this.onClick
					},
				},
			};
		},
		computed: {
			levv(){
				return this.$store.state.user.levv
			},
			status(){
				return this.$store.state.order.orderStatus
			}
		},
		watch:{
			status(){
				this.getTableInfo();
			}
		},
		methods: {
      onsuccess(){
				this.getTableInfo();
			},
			//查询方法
			searchInfo(){
				this.queryParam.page_index = 1;
				this.getTableInfo();
			},
			// 获取列表信息
			getTableInfo() {
        if(this.selectCompanysArr.length == 0){
           	this.openModalMsg("救援公司查询条件不能为空，请至少选择一项查询");
        }
				let driverId =this.queryParam.driverId;
            driverId = driverId.replace(/[^0-9]/g,'');
				let parm = {
					driverId: driverId,
					name: this.queryParam.name,
					customerIds:  this.selectCompanysArr.join(','),
					page_index: this.queryParam.page_index,
					phone: this.queryParam.phone,
					plateNumber: this.queryParam.plateNumber,
				}
				this.loadingstatus = true;
				//this.$http.get('/mockjs/41/rescue-api/driver/list?vehicleId=&page_index=&phone=&driverNum=&name=')
				this.$http.get(process.env.API_INSURANCE_ROOT  + '/rescue-api/driver/list', {params: parm})
					.then( res => {
						if(res.body.success){
							const resInfo = res.body.data;
							const {pageNum,pages,total,isFirstPage,isLastPage} = resInfo;
							this.pageInfo = {
								pageNum: pageNum,
								pages: pages,
								total: total,
								isFirstPage: isFirstPage,
								isLastPage: isLastPage
							}
							this.orderList = resInfo.list;
							this.loadingstatus = false;
						} else {
							this.openModalMsg(res.body.message);
							this.loadingstatus = false;
						}
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
				})
			},
			//从分页组件获取页码参数
			getPageNo(param) {
				this.queryParam.page_index = param;
				this.getTableInfo();
			},
			//新增救援记录列表
			addRescurList(add){
				const obj = {
					name:"增加救援司机",
					id:'PageRescueDriverEdit',
					route:'/indexhome/rescueDriverEdit',
					No:'file',
					//params:{id: id}
				}
				this.$router.push({path:'/indexhome/rescueDriverEdit',query:{add:add,form:1}});
				this.$store.dispatch('addTab',obj);
			},
			// 点击详情
			handle(driverName,id,bindStatus){
				const obj = {
					name:id+'-'+driverName,
					id:'PageRescueDriverEdit',
					route:'/indexhome/rescueDriverEdit' + id,
					No:'file' + id,
					params:{id: id}
				}
				this.$router.push({path:'/indexhome/rescueDriverEdit' + id,query:{id:id,bindStatus: bindStatus,form:2}});
				this.$store.dispatch('addTab',obj);
			},
			//重置信息
			resetQueryParams:function(){
				this.queryParam = {
					driverId: "",									// 司机编号
					name: "",							        	// 姓名
					page_index: 1,                                  // 页数
					phone: "",		                                // 联系电话
					plateNumber: "",	                            // 在驾车辆（车牌号）
				}
				this.$refs.ztree.reSet(2)
			},
			// 消息弹出框相关
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#rescuedrive-list',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#rescuedrive-list',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	}
		}
	}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// PageRescueDriverList.vue?a9955404